import { Navigate } from 'react-router-dom';
import Home from '.';

const routes = [
  {
    path: '/',
    element: <Navigate to="/home" />,
  },
  {
    path: '/home',
    element: <Home />,
  },
];

export default routes;
